import R from 'app/assets/R'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { BaseTableReport } from 'app/components/tables/BaseTableReport'
import * as S from 'app/components/tables/BaseTableReport/styles'
import { FilterReport } from 'app/components/tables/BaseTableReport/FilterReport'
import 'dayjs/locale/vi'
import React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { useTableHook } from './hook'

const ImportAccountingSoldSellingExpensesWeeklyContainer: React.FC = () => {
  const {
    columns,
    tableData,
    handleTableChange,
    expandedRowKeys,
    handleExpand,
    handleChangeFilter,
    urlDownload,
    onClickImport,
  } = useTableHook()

  return (
    <S.BaseReportWrapper>
      <HeaderPage
        titleI18nKey={R.strings.cost_of_goods_sold_and_selling_expenses}
        isImport
        urlExample={urlDownload.url}
        nameFileExample={urlDownload.name}
        onPressImport={onClickImport}
      />
      <S.RootWrapper>
        <S.HeadWrapper>
          <FilterReport
            isHaveChooseWeek={false}
            isHaveChooseMonth={false}
            isSelectFilter
            handleChangeFilter={handleChangeFilter}
            selectFilterGroup="MONTH_QUARTER"
            initSelectEnum="MONTH"
          />
        </S.HeadWrapper>
        <BaseTableReport
          columns={columns}
          dataSource={tableData.data}
          loading={tableData.loading}
          onChange={handleTableChange}
          expandable={{
            expandedRowKeys,
            onExpand: handleExpand,
            defaultExpandAllRows: true,
            expandIcon: () => null,
            rowExpandable: record =>
              record?.children && record?.children?.length > 0,
          }}
          rowClassName="row-overwrite-style"
          pagination={false}
          scroll={{ x: true, y: tableData?.data?.length ? 480 : undefined }}
        />
      </S.RootWrapper>
    </S.BaseReportWrapper>
  )
}

export default ImportAccountingSoldSellingExpensesWeeklyContainer
